import SocialLinks from "./soialLink";
import react,{useState} from "react";
import emailjs from '@emailjs/browser';
const Contact = props => {
  const [name, setName] = useState(null);
  const [email, setEmail] = useState(null);
  const [meg,setMeg]=useState('');
  const [comment, setComment] = useState(null);
  const handleSubmit = (e) => {

    e.preventDefault();
    emailjs.send("service_fptpwng", "template_mv71a0c", {
        name,
        email,
        comment
    },'user_TMg9djTqMOFe5LS6Z50t6').then((response) => {
           setMeg('I will contact you soon thank you for your consideration 🙋')
           setEmail('');
           setName('');
           setComment('')
          
        }, (err) => {
            setMeg('Come back later please something is not right 😬')
            setEmail('');
            setName('');
        
            setComment('')
        });

        setMeg('');
}

    return (
      <section id="contact">
        <div className="container">
          <div className="heading-wrapper">
            <div className="heading">
              <p className="title">
               
                Let get start!🚀
              </p>
              <p className="separator" />
              <p className="subtitle">
                send me a message if you have any questions or want to work together.
              </p>
            </div>
            <SocialLinks />
          </div>
          <h3>{meg && <div className="p-3 text-base">{meg}</div>}</h3>
          <form id="contact-form" action="#" onSubmit={handleSubmit}>
            
            <input placeholder="Name" name="name" type="text" required value={name} onChange={(e) => setName(e.target.value)} />
            <input placeholder="Email" name="email" type="email" required value={email}  onChange={(e) => setEmail(e.target.value)}/>
            <textarea placeholder="Message" type="text" name="comment" value={comment} onChange={(e) => setComment(e.target.value)}/>
            <input className="btn" id="submit" value="Submit" type="submit" />
          </form>
        </div>
      </section>
    );
  };
export default Contact;  